// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__sQR3jQRO0vlC8x96pDYN","textColumnTitle":"textColumnTitle__EqAFe51H5isN3104AL7l","textColumnPara":"textColumnPara__tuY7s93i7y2CGVdDfhp1"};